import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/components/HeroSection/HeroSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import { CLUB_EAGLERIDER_RIDES } from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/utils/Constants';

type HeroSectionProps = {
  selectedEvent: string;
  selectedLocation: string;
};

const HeroSection: FC<HeroSectionProps> = (props) => {
  const { selectedEvent, selectedLocation } = props;
  const content = useContent('EventsListingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const renderPageTitle = () => {
    let pageTitle;
    if (selectedEvent) {
      if (selectedEvent == CLUB_EAGLERIDER_RIDES) {
        pageTitle = content.clubEagleRiderRides;
      } else {
        pageTitle = interpolateString(content.eventTypeSelectedLabel, {
          type_name: selectedEvent,
        });
      }
    } else {
      pageTitle = content.motorcycleEvents;
    }

    if (selectedLocation) {
      pageTitle = interpolateString(content.locationSelectedLabel, {
        page_title: pageTitle,
        location_name: selectedLocation,
      });
    }
    return pageTitle;
  };

  return (
    <StyledBox>
      <Box className="HSBGContainer">
        <ImgBox
          image={{
            src: getSizedImage(content.heroBackground),
            alt: content.heroBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
        <Box className="HSBGGradient" />
        <Box className="HSBGPattern">
          <ImgBox
            image={{
              src: getSizedImage(content.patternBackground),
              alt: content.patternBackground.alt,
            }}
            width="100%"
            height="100%"
            unoptimized
          />
        </Box>
      </Box>

      <Box className="HSContentContainer">
        <Typography variant="h3" component="h1" pb={1.75} className="HSTitle">
          {renderPageTitle()}
        </Typography>
        <Typography variant="body2" component="p" color="text.secondary">
          {content.heroSubtitle}
        </Typography>
      </Box>
    </StyledBox>
  );
};

export { HeroSection };
